import styled, { keyframes } from 'styled-components';
import theme from '../../theme';

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.6;
  }
`;

const SkeletonBase = styled.div`
  background-color: ${theme.colors.NEUTRAL_20};
  border-radius: ${({ $circle }) => $circle ? '50%' : '4px'};
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '20px'};
  margin: ${({ margin }) => margin || '0'};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const TextSkeleton = styled(SkeletonBase)`
  width: ${({ width }) => width || '120px'};
  height: ${({ height }) => height || '20px'};
  border-radius: 4px;
`;

const CircleSkeleton = styled(SkeletonBase)`
  width: ${({ size }) => size || '200px'};
  height: ${({ size }) => size || '200px'};
  border-radius: 50%;
`;

const Skeleton = {
  Base: SkeletonBase,
  Text: TextSkeleton,
  Circle: CircleSkeleton,
};

export default Skeleton;
